import { gql } from '@apollo/client';

export const MANIFEST_SUMMARY_VIEW_FIELDS = gql`
    fragment ManifestSummaryViewFields on manifest_summary_view {
        manifest_id
        manifest_status
        item_object_count
        order_count
        total_qty
        received_qty
        staged_qty
        picked_up_qty
    }
`;
